module.exports = require('./helpers/bundle-url').getBundleURL('hcTqB') + "rocket-success.3da0828a.svg";